const ENDPOINTS = {
    LOGIN: '/stocklocatevalidationapi/StockLocateValidation/Login',
    LOGOUT: '/stocklocatevalidationapi/StockLocateValidation/Logout',
    VALIDATE: '/stocklocatevalidationapi/StockLocateValidation/Validate',
    SUBMIT: '/stocklocatevalidationapi/StockLocateValidation/SubmitLocateRequest',
    REVIEW_REPORT: '/stocklocatevalidationapi/StockLocateValidation/ReviewReport',
    UPDATE_ALLOCATION: '/stocklocatevalidationapi/StockLocateValidation/UpdateAllocatoion',
    ETB_REPORT: '/stocklocatevalidationapi/StockLocateValidation/ETBReport',
    UPDATE_ETB: '/stocklocatevalidationapi/StockLocateValidation/UpdateETB',
    INVENTORY_REPORT: '/stocklocatevalidationapi/StockLocateValidation/InventoryReport',
    UPDATE_INVENTORY: '/stocklocatevalidationapi/StockLocateValidation/UpdateInventory'
}

export default ENDPOINTS